<template>
  <v-data-table
    :headers="headers"
    :items="events"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="Event-button-new"
          :to="{
            name: 'membership-EditEvent'
          }"
        >
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.date="{ item }">
      {{ formatDateTime(item.date) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn-toggle>
        <v-btn
          color="primary"
          small
          :to="{ name: 'membership-ListEventAttendance', query: { eventId: item.id }}"
        >
          {{ $$t('attendees')}}
        </v-btn>
        <v-btn
          color="default"
          small
          :to="{ name: 'membership-EditEvent', query: { id: item.id }}"
        >
          {{ $t('common.buttons.edit')}}
        </v-btn>
        <v-btn color="error" small @click="remove(item)">
          {{ $t('common.buttons.delete')}}
        </v-btn>
      </v-btn-toggle>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import org from '@codehq/aurora-app-core/src/mixins/org';

export default {
  name: 'ListEvent',
  module: 'Event',
  mixins: [loading, org],
  computed: {
    /** Vuex states
     */
    ...mapState('events', ['events']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: this.$$t('date'),
          value: 'date',
        },
        {
          text: this.$$t('organizedBy'),
          value: 'organizedBy',
        },
        {
          text: this.$$t('location'),
          value: 'location',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('events', ['LOAD_events', 'DELETE_event']),
    /** Refresh data - also used as auto refresh for when org changes
     */
    async refresh() {
      this.isLoading = true;
      await this.LOAD_events();
      this.isLoading = false;
    },
    /** Delete Event from the collection
     */
    async remove(Event) {
      const result = await this.$confirm(this.$t('common.phrases.confirmDelete'));
      if (result) {
        this.isLoading = true;
        await this.DELETE_Event(Event);
        this.isLoading = false;
      }
    },
  },
};
</script>

<docs>
# Event example

'''js
<Event />
'''
</docs>
